import { StimulusAttribution } from '../stimulus.constants';

export function hasAttributionContent(attribution: StimulusAttribution | null) {
  return (
    attribution?.author ||
    attribution?.copyright ||
    attribution?.licence ||
    attribution?.modifications
  );
}
